<template>
    
    <b-row>
        <b-col cols='12'>
            
            <!-- <app-timeline> -->
                <app-timeline-item
                    :variant="item.status == 'open'? 'success' : 'secondary' "
                    icon="ShoppingBagIcon"
                >
                    <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                    <h5>  {{ item.actionType.description }}</h5>
                    </div>
                    <b-row
                    class="d-flex justify-content-between align-items-center bg-transparent"
                    >
                        <b-col md="3" cols="3"><p>التاريخ اللازم لبدء الإجراء  : {{ item.start_date }}</p></b-col>
                        
                        <b-col md="3" cols="3"><p>التاريخ اللازم لإنهاء الإجراء  : {{ item.end_date }}</p></b-col>
                        <b-col md="3" cols="3"><p>   نتيجة الدراسة  :  <transactions-status-formatter :value="item.status" /></p></b-col>
                        <b-col md="3" cols="3"><p>  الملاحظات  : {{ item.notes }}</p></b-col>
                    
                    </b-row>
                    <b-row v-if="item.hasOwnProperty('actionHistoryDocs') && item.actionHistoryDocs.length>0" >
                        <b-col cols="12" class="mt-1">المُرفقات :</b-col>
                        <b-col cols="12" class="mt-1">
                            <b-table striped hover  :fields="fields" :items="item.actionHistoryDocs">
                                <template #cell(file)="{ item }">
                                    <b-button
                                        v-if="item.type === 'application/pdf'"
                                        size="sm"
                                        @click="$router.push({ name: 'file-view', query: { ep: item.value } })"
                                        variant="flat-success"
                                    >
                                        <feather-icon class="mx-25" icon="EyeIcon" />
                                        عرض المُرفق
                                    </b-button>
                                    <b-button
                                        v-else
                                        size="sm"
                                        @click="showImage = true; pathImage =item.file "
                                        variant="flat-success"
                                    >
                                        <feather-icon class="mx-25" icon="EyeIcon" />
                                        عرض المُرفق
                                        
                                    </b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-button
                    v-if="item.actionMinistryUserHistories.length > 0"
                    v-b-toggle.report-list-with-icon
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    size="sm"
                    variant="outline-primary"
                    >
                    عرض من قام بهذا الإجراء
                    </b-button>
                    <b-collapse :id="`report-list-with-icon-${item}`">
                    <b-list-group
                        flush
                        class="mt-1"
                    >
                        <b-list-group-item
                        v-for="el in item.actionMinistryUserHistories"
                        :key="el"
                        href="#"
                        class="d-flex justify-content-between align-items-center bg-transparent"
                        >
                            <span> {{ el.ministryUser.full_name }}</span>
                            <span> {{ el.ministryUser.full_name }}</span>
                            <span>2023-12-12</span>
                        </b-list-group-item>
                       
                    </b-list-group>
                    </b-collapse>
                </app-timeline-item>
            <!-- </app-timeline> -->
        </b-col>
        
        <b-modal
            title="الصورة المُرفقة"
            size="lg"
            v-model="showImage"
            footer-class="removed"
            >
            <b-img
                style="height: 50%; width: 100%"
                :src="pathImage"
                rounded
                fluid
                alt="profile photo"
            />
        </b-modal>
    </b-row>
</template>

<script>
import { BCol , BRow , VBToggle , VBTooltip , BButton, BCollapse , BListGroup, BListGroupItem , BTable , BModal , BImg} from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import TransactionsStatusFormatter from "@/modules/ngo/transactions/components/TransactionsStatusFormatter.vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
     BCol , InfoCard , BRow , BButton ,  AppTimeline, AppTimelineItem , BCollapse , BListGroup, BListGroupItem , TransactionsStatusFormatter , BTable , BModal , BImg
    },
    props: {
        actionHistories: Array  ,
        item: Object  ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
        Ripple
    },
    data() {
      return {
        showImage : false ,
        pathImage : '',
        fields: [
        { key: "id", label: "المعرف" },
        { key: "title", label: "عنوان المُرفق" },
        { key: "file", label: "" },
      ],
      }
    }
};
</script>